import { CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE } from '../../constants'
import Api from '../../services/api.js'

export function changePasswordRequest() {
  return {
    type: CHANGE_PASSWORD_REQUEST
  }
}

export function changePasswordSuccess() {
  return {
    type: CHANGE_PASSWORD_SUCCESS
  }
}

export function changePasswordFailure(error) {
  return {
    type: CHANGE_PASSWORD_FAILURE,
    error: error,
  }
}

export function changePassword(details) {
  return dispatch => {
    dispatch(changePasswordRequest())
    const api = new Api();
    return api.post("/__api/v1/reset_password", details)
    .then(response => {
      if (response.status === 201){
        dispatch(changePasswordSuccess())
      }
    })
    .catch(exception => dispatch(changePasswordFailure(exception.response.data.error)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/password/change.js